import api from "../common/services/liferay/api";
import {Liferay} from "../common/services/liferay/liferay";

export const getDetailProductSetting = async (productSettingId) => {

    const resp = await api(`/api/jsonws/invoke`, {
        method: 'POST',
        body: new URLSearchParams({
            cmd: JSON.stringify({
                '/digitalsale.surpriseboxsetting/get-product-setting': {
                    productSettingId: Number(productSettingId)
                },
            }),
            p_auth: Liferay.authToken
        }),
    });

    const data = await resp.json();

    return JSON.parse(data);
}